import {
    SHOW_PDP_TRADE_NEGOTIATION_TOAST,
    SHOW_PDP_TRADE_NEGOTIATION_MODAL,
    SHOW_PDP_TRADE_ON_APPROVAL_CALLOUT,
    SHOW_PDP_TRADE_HOLD_REQUEST_TOAST,
} from '../pdpSharedNotificationConstants';
import { localStorage } from 'dibs-browser-storage';

/* if the given txn was checked out in the past 6 months return true */
const SIX_MONTHS = 6 * 30 * 24 * 60 * 60 * 1000;
export const hasRecentTransaction = mostRecentTransaction => {
    if (!mostRecentTransaction || !mostRecentTransaction.checkoutDate) {
        return false;
    }

    const transactionDate = new Date(mostRecentTransaction.checkoutDate);
    return transactionDate.getTime() + SIX_MONTHS >= Date.now();
};

const MICRO_GOAL_CYCLE_COMPLETION_DATES_STORAGE_KEY = 'tradeMicroGoalsViewDates';
/* only show the full micro goal cycle up to 2 times in a week */
const WEEKLY_VIEW_CAP = 2;
/* only show the full micro goal cycle up to 5 times in a month */
const MONTHLY_VIEW_CAP = 5;
const ONE_DAY = 1000 * 60 * 60 * 24;
const isAtViewCap = (viewCap, numberOfDays) => {
    const microGoalCycleCompletionDates =
        localStorage.getItem(MICRO_GOAL_CYCLE_COMPLETION_DATES_STORAGE_KEY) || [];
    const previousMicroGoalCycleCompletionDate = microGoalCycleCompletionDates[viewCap - 1];
    if (!previousMicroGoalCycleCompletionDate) {
        return false;
    }

    const daysAgo = (Date.now() - previousMicroGoalCycleCompletionDate) / ONE_DAY;
    return daysAgo < numberOfDays;
};
export const isAtWeeklyViewCap = () => isAtViewCap(WEEKLY_VIEW_CAP, 7);
export const isAtMonthlyViewCap = () => isAtViewCap(MONTHLY_VIEW_CAP, 28);
/* store up to 5 timestamps to track views of the micro goal cycle */
export const setMicroGoalViewedDate = () => {
    const microGoalCycleCompletionDates =
        localStorage.getItem(MICRO_GOAL_CYCLE_COMPLETION_DATES_STORAGE_KEY) || [];

    //add today's date as the most recent view date
    microGoalCycleCompletionDates.unshift(Date.now());
    //if the count of view dates is greater than MONTHLY_VIEW_CAP, pop the oldest date
    if (microGoalCycleCompletionDates.length > MONTHLY_VIEW_CAP) {
        microGoalCycleCompletionDates.pop();
    }

    localStorage.setItem(
        MICRO_GOAL_CYCLE_COMPLETION_DATES_STORAGE_KEY,
        microGoalCycleCompletionDates
    );
};

const MICRO_GOAL_INDEX_STORAGE_KEY = 'tradeMicroGoals';
/* users should cycle through the micro goal callouts in the order of this array */
export const MICRO_GOAL_CYCLE_QUEUE = [
    SHOW_PDP_TRADE_NEGOTIATION_TOAST,
    SHOW_PDP_TRADE_NEGOTIATION_MODAL,
    SHOW_PDP_TRADE_ON_APPROVAL_CALLOUT,
    SHOW_PDP_TRADE_HOLD_REQUEST_TOAST,
];
const MICRO_GOAL_CYCLE_QUEUE_MAX_INDEX = MICRO_GOAL_CYCLE_QUEUE.length - 1;

/* get the current microgoal index as stored in local storage */
export const getCurrentMicroGoalIndex = () =>
    localStorage.getItem(MICRO_GOAL_INDEX_STORAGE_KEY) || 0;

/* get the current microgoal */
export const getCurrentMicroGoal = () => MICRO_GOAL_CYCLE_QUEUE[getCurrentMicroGoalIndex()];

/* update local storage to the next index after the index of the given microgoal */
export const setMicroGoalAsViewed = microGoal => {
    const goalIndex = MICRO_GOAL_CYCLE_QUEUE.indexOf(microGoal);
    localStorage.setItem(
        MICRO_GOAL_INDEX_STORAGE_KEY,
        goalIndex >= MICRO_GOAL_CYCLE_QUEUE_MAX_INDEX ? 0 : goalIndex + 1
    );
};
